import React from "react";
import useOnScreen from "../../../hooks/useOnScreen";

const painPointAnswers = [
  {
    id: "pain-answer-1",
    answerParts: [
      { text: "Beasiswa LPDP, Fulbright, Australia Awards, semua butuh" },
      { text: "IELTS minimal 6.0-6.5", bold: true },
      { text: ". Tanpa skor itu, berkas kamu bahkan tidak akan dibuka." },
    ],
  },
  {
    id: "pain-answer-2",
    answerParts: [
      { text: "Mau les IELTS tapi" },
      { text: "grammar masih kacau", bold: true },
      { text: "? Banyak kursus langsung masuk materi tanpa memperkuat fondasi." },
    ],
  },
  {
    id: "pain-answer-3",
    answerParts: [
      { text: "Skor stuck di 5.0-5.5 meski udah belajar berbulan-bulan? Masalahnya bukan malas, tapi" },
      { text: "metodenya kurang tepat", bold: true },
      { text: "!" },
    ],
  },
];

const PainPointProduct2 = () => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.2 });

  return (
      <section ref={ref} className="st-surface-navy overflow-x-clip py-12 sm:py-14" id="whyus">
        <div className="mx-auto w-full max-w-6xl px-6 py-10 sm:px-8 sm:py-12 lg:px-12 lg:py-14">
          <div className="grid items-start gap-8 lg:grid-cols-[1fr_1.1fr] lg:gap-10">
            <div className={`${isVisible ? "animate__animated animate__fadeInLeft" : ""}`}>
              <h2
                className="st-font-display st-text-cream-heading text-[52px] leading-[1.02] sm:text-[58px] lg:text-[45px]"
              >
                <em className="font-normal">Kenapa</em> <span className="font-bold">banyak</span>
                <br />
                <em className="font-normal">yang</em> <span className="font-bold">gagal lolos</span>
                <br />
                <em className="font-normal">beasiswa?</em>
              </h2>
  
              <p
                className="st-font-body st-text-cream mt-[2.5rem] max-w-md text-[29px] leading-[1.3] sm:text-[22px] lg:mt-[10rem]"
              >
                Banyak yang <strong>gagal</strong> meraih beasiswa karena <strong>kesalahan</strong> saat
                <strong> persiapan</strong> IELTS. Yuk mulai <strong>perbaiki</strong> dari sekarang!
              </p>
            </div>
  
            <div className={`${isVisible ? "animate__animated animate__fadeInRight" : ""}`}>
              <div className="space-y-4">
                {painPointAnswers.map((item) => (
                  <div
                    key={item.id}
                    className={`overflow-hidden rounded-[8px] border-l-[10px] border-l-[--st-color-red] bg-[--st-color-cream] ${isVisible ? "animate__animated animate__fadeInUp" : ""}`}
                  >
                    <p className="st-font-body px-5 py-5 text-[18px] leading-[1.35] text-[--st-color-text] sm:px-6 sm:text-[20px]">
                      {item.answerParts.map((part, index) => (
                        <React.Fragment key={`${item.id}-part-${index}`}>
                          {part.bold ? <strong className="text-[--st-color-red]">{part.text}</strong> : part.text}
                          {index < item.answerParts.length - 1 ? " " : ""}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default PainPointProduct2;
